import React, { useState, useEffect } from "react";
import MainContainer from "../../components/MainContainer";
import MainHeader from "../../components/MainHeader";
import Title from "../../components/Title";
import { makeStyles, Paper, Tabs, Tab } from "@material-ui/core";

import TabPanel from "../../components/TabPanel";

import SchedulesForm from "../../components/SchedulesForm";
// import CompaniesManager from "../../components/CompaniesManager"; // ✅ NO USADO - Reemplazado por CompaniesManagerImproved
import CompaniesManagerImproved from "../../components/CompaniesManager/CompaniesManagerImproved";
// import HelpsManager from "../../components/HelpsManager"; // ✅ NO USADO - Reemplazado por HelpsManagerImproved
import HelpsManagerImproved from "../../components/HelpsManager/HelpsManagerImproved";
import Options from "../../components/Settings/Options";
import ThemeSelector from "../../components/Settings/ThemeSelector";
// import SMTPConfig from "../../components/Settings/SMTPConfig"; // ⚠️ DEPRECADO - Reemplazado por SMTPConfigManager
import SubscriptionsConfig from "../../components/Settings/SubscriptionsConfig";
import WebConfig from "../../components/Settings/WebConfig";
// import Performance from "../../components/Settings/Performance"; // ✅ MOVIDO A Dashboard > Rendimiento CPU
import VersionInfo from "../../components/Settings/VersionInfo";
// ✅ NUEVO: Componente DB-FIRST para SMTP (incluye Plantillas internamente)
import SMTPConfigManager from "../Settings/components/SMTPConfigManager";
// ✅ NUEVO: Componente para notificaciones VPS
import NotificationAlertsConfig from "../Settings/components/NotificationAlertsConfig";

import { i18n } from "../../translate/i18n.js";
import { toast } from "react-toastify";

import useCompanies from "../../hooks/useCompanies";
import useAuth from "../../hooks/useAuth.js";
import useSettings from "../../hooks/useSettings";

import OnlyForSuperUser from "../../components/OnlyForSuperUser";

const useStyles = makeStyles((theme) => ({
  root: {
    flex: 1,
    backgroundColor: theme.palette.background.paper,
  },
  mainPaper: {
    ...theme.scrollbarStyles,
    overflowY: "scroll",
    flex: 1,
    backgroundColor: theme.palette.background.paper,
  },
  // ✅ CORREGIDO: Estilos para contenedor de Tabs
  tabsContainer: {
    backgroundColor: theme.palette.background.paper,
    "& .MuiTabs-root": {
      backgroundColor: theme.palette.background.paper,
      borderBottom: `1px solid ${theme.palette.divider || (theme.mode === 'dark' ? '#374151' : '#e0e0e0')}`,
    },
    "& .MuiTabs-flexContainer": {
      backgroundColor: theme.palette.background.paper,
    },
    "& .MuiTab-root": {
      color: theme.palette.text.primary,
      backgroundColor: theme.palette.background.paper,
      "&:hover": {
        backgroundColor: theme.mode === 'dark' ? '#374151' : '#f5f5f5',
      },
      "&.Mui-selected": {
        color: theme.palette.primary.main,
        backgroundColor: theme.palette.background.paper,
      },
    },
    "& .MuiTabs-indicator": {
      backgroundColor: theme.palette.primary.main,
    },
  },
  tab: {
    backgroundColor: theme.palette.options,
    borderRadius: 4,
  },
  paper: {
    ...theme.scrollbarStyles,
    overflowY: "scroll",
    padding: theme.spacing(2),
    display: "flex",
    alignItems: "center",
    width: "100%",
    backgroundColor: theme.palette.background.paper,
  },
  container: {
    width: "100%",
    maxHeight: "100%",
  },
  control: {
    padding: theme.spacing(1),
  },
  textfield: {
    width: "100%",
  },
}));

const SettingsCustom = () => {
  const classes = useStyles();
  const [tab, setTab] = useState("options");
  const [schedules, setSchedules] = useState([]);
  const [company, setCompany] = useState({});
  const [loading, setLoading] = useState(false);
  const [currentUser, setCurrentUser] = useState({});
  const [settings, setSettings] = useState({});
  const [schedulesEnabled, setSchedulesEnabled] = useState(false);

  const { getCurrentUserInfo } = useAuth();
  const { find, updateSchedules } = useCompanies();
  const { getAll: getAllSettings } = useSettings();

  useEffect(() => {
    async function findData() {
      setLoading(true);
      try {
        const companyId = localStorage.getItem("companyId");
        const company = await find(companyId);
        const settingList = await getAllSettings();
        setCompany(company);
        setSchedules(company.schedules);
        setSettings(settingList);

        if (Array.isArray(settingList)) {
          const scheduleType = settingList.find(
            (d) => d.key === "scheduleType"
          );
          if (scheduleType) {
            setSchedulesEnabled(scheduleType.value === "company");
          }
        }

        const user = await getCurrentUserInfo();
        setCurrentUser(user);
      } catch (e) {
        toast.error(e);
      }
      setLoading(false);
    }
    findData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleTabChange = (event, newValue) => {
      async function findData() {
        setLoading(true);
        try {
          const companyId = localStorage.getItem("companyId");
          const company = await find(companyId);
          const settingList = await getAllSettings();
          setCompany(company);
          setSchedules(company.schedules);
          setSettings(settingList);
  
          if (Array.isArray(settingList)) {
            const scheduleType = settingList.find(
              (d) => d.key === "scheduleType"
            );
            if (scheduleType) {
              setSchedulesEnabled(scheduleType.value === "company");
            }
          }
  
          const user = await getCurrentUserInfo();
          setCurrentUser(user);
        } catch (e) {
          toast.error(e);
        }
        setLoading(false);
      }
      findData();
      // eslint-disable-next-line react-hooks/exhaustive-deps

    setTab(newValue);
  };

  const handleSubmitSchedules = async (data) => {
    setLoading(true);
    try {
      setSchedules(data);
      await updateSchedules({ id: company.id, schedules: data });
      toast.success(i18n.t("settings.schedules.success"));
    } catch (e) {
      toast.error(e);
    }
    setLoading(false);
  };

  const isSuper = () => {
    return currentUser.super;
  };

  // 0390 FT-5 — quién ve la pestaña de apariencia. La autoridad real es el
  // backend, que exige `settings:administrar` en `PUT /theme/company`: esto solo
  // evita mostrar una pestaña que acabaría en un 403.
  const puedeAdministrar = () => {
    return Boolean(currentUser.super) || currentUser.profile === "admin";
  };

  return (
    <MainContainer className={classes.root}>
      <MainHeader>
        <Title>{i18n.t("settings.title")}</Title>
      </MainHeader>
      <Paper className={classes.mainPaper} elevation={1}>
        <div className={classes.tabsContainer}>
          <Tabs
            key={i18n.language}
            value={tab}
            indicatorColor="primary"
            textColor="primary"
            scrollButtons="on"
            variant="scrollable"
            onChange={handleTabChange}
          >
            <Tab label={i18n.t("settings.tabs.options")} value={"options"} />
            {/* 0390 FT-5 — el tema alcanza a toda la empresa: solo quien administra */}
            {puedeAdministrar() ? <Tab label="Apariencia" value={"appearance"} /> : null}
            {schedulesEnabled && <Tab label={i18n.t("settings.tabs.schedules")} value={"schedules"} />}
            {isSuper() ? <Tab label={i18n.t("settings.tabs.version")} value={"version"} /> : null}
            {isSuper() ? <Tab label={i18n.t("settings.tabs.smtp")} value={"smtp"} /> : null}
            {isSuper() ? <Tab label={i18n.t("settings.tabs.alerts")} value={"alerts"} /> : null}
            {isSuper() ? <Tab label={i18n.t("settings.tabs.subscriptions")} value={"subscriptions"} /> : null}
            {isSuper() ? <Tab label={i18n.t("settings.tabs.logo")} value={"web"} /> : null}
            {/* ✅ ELIMINADO: Tab "Rendimiento" movido a Dashboard > Rendimiento CPU */}
            {isSuper() ? <Tab label={i18n.t("settings.tabs.companies")} value={"companies"} /> : null}
            {isSuper() ? <Tab label={i18n.t("settings.tabs.help")} value={"helps"} /> : null}
          </Tabs>
        </div>
        <Paper className={classes.paper} elevation={0}>
          {/* 0390 FT-5 — selector de tema de la empresa */}
          <TabPanel className={classes.container} value={tab} name={"appearance"}>
            <ThemeSelector />
          </TabPanel>
          <TabPanel
            className={classes.container}
            value={tab}
            name={"schedules"}
          >
            <SchedulesForm
              loading={loading}
              onSubmit={handleSubmitSchedules}
              initialValues={schedules}
            />
          </TabPanel>
          <OnlyForSuperUser
            user={currentUser}
            yes={() => (
              <TabPanel
                className={classes.container}
                value={tab}
                name={"companies"}
              >
                <CompaniesManagerImproved />
              </TabPanel>
            )}
          />
          <OnlyForSuperUser
            user={currentUser}
            yes={() => (
              <TabPanel
                className={classes.container}
                value={tab}
                name={"helps"}
              >
                <HelpsManagerImproved />
              </TabPanel>
            )}
          />
          <TabPanel className={classes.container} value={tab} name={"options"}>
            <Options
              settings={settings}
              scheduleTypeChanged={(value) =>
                setSchedulesEnabled(value === "company")
              }
            />
          </TabPanel>
          <OnlyForSuperUser
            user={currentUser}
            yes={() => (
              <TabPanel className={classes.container} value={tab} name={"version"}>
                <VersionInfo />
              </TabPanel>
            )}
          />
          <OnlyForSuperUser
            user={currentUser}
            yes={() => (
              <TabPanel className={classes.container} value={tab} name={"smtp"}>
                <SMTPConfigManager />
              </TabPanel>
            )}
          />
          <OnlyForSuperUser
            user={currentUser}
            yes={() => (
              <TabPanel className={classes.container} value={tab} name={"alerts"}>
                <NotificationAlertsConfig />
              </TabPanel>
            )}
          />
          <OnlyForSuperUser
            user={currentUser}
            yes={() => (
              <TabPanel className={classes.container} value={tab} name={"subscriptions"}>
                <SubscriptionsConfig />
              </TabPanel>
            )}
          />
          <OnlyForSuperUser
            user={currentUser}
            yes={() => (
              <TabPanel className={classes.container} value={tab} name={"web"}>
                <WebConfig />
              </TabPanel>
            )}
          />
          {/* ✅ ELIMINADO: TabPanel "performance" movido a Dashboard > Rendimiento CPU */}
        </Paper>
      </Paper>
    </MainContainer>
  );
};

export default SettingsCustom;
